import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { CommentId } from '@root/entities/comment/model/comment-id'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

interface BackOfficeCommentDeletePayload {
  commentId: CommentId
}

export const reatomBackOfficeCommentDeleteRequestAction = action(
  async (ctx, data: BackOfficeCommentDeletePayload) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.admin.adminCommentsDelete, [
        {
          commentId: data.commentId,
        },
      ]),
    )

    return result.pipe(
      Result.map((dto) => ({
        commentId: CommentId(dto.commentId),
        success: dto.success,
      })),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'reatomBackOfficeCommentDeleteRequestAction',
)
